/**
 * CommonMessageException automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {KnownStatusCodeException} from "sdkgen-client"

import {CommonMessage} from "./CommonMessage";

export class CommonMessageException extends KnownStatusCodeException {

    public constructor(private payload: CommonMessage) {
        super('The server returned an error');
    }

    public getPayload(): CommonMessage {
        return this.payload;
    }

}
